import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Order_Details_Card from "../order_details_card/Order_Details_Card";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrder, getAllReturnOrder } from "../../../../features/order/orderSlice";
import { encodeId } from "../../../../utils/common";

const Return = ({ type }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate("/return-order-details");
  };

  const data = [
    {
      order_id: 75843,
      item_no: 1,
      price: 1200,
      date: "13th May | 03:28 pm",
    },
  ];

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.allReturnOrders);

  useEffect(() => {
    const statusIds = [8];
    dispatch(getAllReturnOrder({ order_status_id: statusIds }));
  }, [dispatch]);

  return (
    <section className="Return Ordered">
      {order?.data?.map((item) => {
        return (
          <Order_Details_Card
            // data={item}
            type={type}
            key={item.order_id}
            data={item}
            showTrackOrder={true}
            track_order_text="Order Return Tracking"
            onClick={handleCardClick}
            baseLike={`/return-order-details/${encodeId(item?.id)}?type=Return`}
          />
        );
      })}

      <div className="no_data_main_div">
        <p className="no_data_text">No more orders to show</p>
      </div>
    </section>
  );
};

export default Return;
